import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";
import { Info } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";

const InfoTooltip = ({ text }) => {
  const { theme, colors } = useTheme();
  const [show, setShow] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null);

  useEffect(() => {
    if (show && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      // setPosition({
      //   top: rect.top + window.scrollY,
      //   left: rect.right + 10 + window.scrollX,
      // });
      setPosition({
      top: rect.bottom + 8 + window.scrollY, // show below
      left: rect.left - 100 + window.scrollX,      // align with icon
    });
    }
  }, [show]);
  useEffect(() => {
  if (!show) return;

  const handleScroll = () => {
    setShow(false);
  };

  window.addEventListener("scroll", handleScroll, true);

  return () => {
    window.removeEventListener("scroll", handleScroll, true);
  };
}, [show]);
  
  return (
    <div className="relative inline-flex">
      <span
        ref={buttonRef}
         role="button"
        onClick={() => setShow(!show)}
        className="flex items-center justify-center w-5 h-5 rounded-full transition-all duration-200 hover:scale-110"
        style={{
          backgroundColor: show ? `${colors.primary}20` : `${colors.primary}15`,
          color: colors.primary,
        }}
        aria-label="View details"
      >
        <Info className="w-3 h-3" />
      </span>

      {show &&
        createPortal(
          <>
            <div
              className="fixed inset-0 z-[9998]"
              onClick={() => setShow(false)}
            />

            <motion.div
              className="fixed rounded-lg shadow-xl border z-[9999] w-[260px]"
              style={{
                backgroundColor:
                  theme === "white" ? "#ffffff" : colors.background,
                borderColor: `${colors.primary}30`,
                boxShadow: `0 8px 32px ${colors.primary}30`,
                top: position.top,
                left: position.left,position: "absolute",
              }}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.2 }}
            >
              <div className="px-4 py-3">
                <p
                  className="text-sm leading-relaxed"
                  style={{ color: colors.textSecondary }}
                >
                  {text}
                </p>
              </div>
            </motion.div>
          </>,
          document.body
        )}
    </div>
  );
};

export default InfoTooltip;